<template>
<v-flex>
    <h1 style="color: #969462 !important;">Informações Relevantes</h1>
    <div class="elevation-3">
        <div class="tableHeader">
            <v-dialog v-model="modal" persistent max-width="700px">
                <v-btn slot="activator" color="#969462" dark class="mb-2">
                    <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Nova {{name}}
                </v-btn>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-form ref="form" v-on:submit.prevent>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex v-if="editedIndex==-1" xs12 sm12 md12>
                                        <label class="label-modal">Destinatários</label>
                                        <v-select color="#969462" v-model="toSend" :items="clientes" :menu-props="{ maxHeight: '400' }" @change="changeSelect" item-text="nome" item-value="id_utilizador" multiple></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Título</label>
                                        <v-text-field color="#969462" counter maxlength="200" :autofocus="true" :rules="defaultRules" v-model="editedItem.titulo"></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Descrição</label>
                                        <v-textarea rows="2" color="#969462" counter maxlength="20000" :rules="defaultRules" v-model="editedItem.descricao"></v-textarea>
                                    </v-flex> -->
                                    <v-flex xs12 sm12 md12>
                                        <quill-editor v-model="editedItem.descricao"></quill-editor>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#969462" flat @click.native="close">Cancelar</v-btn>
                            <v-btn color="#969462" flat @click.native="save">Guardar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-text-field color="#969462" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </div>

        <v-dialog v-model="deleteM" persistent max-width="390">
            <v-card>
                <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                <v-card-text>De certeza que quer apagar este {{name}}?</v-card-text>
                <v-card-actions style="margin-top: 0px !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="#969462" flat="flat" @click.native="close">Cancelar</v-btn>
                    <v-btn color="#969462" flat="flat" @click.native="save">Apagar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
            <template slot="items" slot-scope="props">
                <td @click="editItem(props.item, true)" style="width: 15%;" class="textLeft">{{ props.item.id_aviso }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.titulo }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.data }}</td>
                <td class="px-0 textTable textCenter">
                    <v-btn icon class="mx-0" @click="editItem(props.item, true)">
                        <v-icon color="light-green darken-1">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                        <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                </td>
            </template>

            <template class="alertTable" slot="no-data">
                <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert>
            </template>
        </v-data-table>

    </div>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";
const cName = {
    upper: "Informação",
    lower: "a informação!"
};

import 'vuetify/dist/vuetify.min.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
    quillEditor
} from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    data: () => ({
        table: 'avisos',
        name: 'informação',
        search: "",
        modal: false,
        deleteM: false,
        loading: true,
        searchP: '',
        toSend: [],
        clientes: [],
        headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_aviso"
            },
            {
                text: "Título",
                align: "left",
                sortable: true,
                value: "titulo"
            },
            {
                text: "Data",
                align: "left",
                sortable: true,
                value: "data"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
        ],
        DATA: [],
        editedIndex: -1,
        editedItem: {
            id_aviso: '',
            titulo: "",
            descricao: "",
            data: "",
        },
        defaultItem: {
            id_aviso: '',
            titulo: "",
            descricao: "",
            data: "",
        },
        messages: {
            add: {
                success: cName.upper + " criada com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterada com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminada com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        },
        defaultRules: null
    }),

    computed: {
        ...mapGetters({
            getAll: 'avisos/getAll',
            getClientes: 'utilizadores/getClientes'
        }),
        formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    },

    watch: {
        modal(val) {
            val || this.close()
        },
        deleteM(val) {
            val || this.close()
        },
        getAll(val) {
            this.initialize()
        }
    },

    created() {
        this.defaultRules = [v => !!v || this.$requiredField + ''];

        setTimeout(() => {
            this.clientes = [].concat(this.getClientes);
            this.clientes.unshift({
                id_utilizador: 0,
                nome: 'Todos'
            })
        }, 1000);

        this.initialize();
    },
    mounted() {

    },
    methods: {
        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        changeSelect() {
            if (this.toSend.findIndex((el) => {
                    return el == 0
                }) > -1) this.toSend = this.clientes.map((el) => {
                return el.id_utilizador
            });
        },

        initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },

        editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = Object.assign({}, item);

            if (dialog) this.modal = true;
            else this.deleteM = true;
        },

        delete() {
            if (!this.editedItem.id_aviso) return;

            this.$store
                .dispatch(this.table + "/delete", {
                    id: this.editedItem.id_aviso
                })
                .then((res) => {
                    if (res) {
                        this.toast('success', this.messages.delete.success);
                        this.initialize();
                    } else this.toast('error', this.messages.delete.error);

                    this.deleteM = false;
                });
        },

        close() {
            this.modal = this.deleteM = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.toSend = [];

                this.$refs.form.reset();
            }, 110);
        },

        save() {
            if (this.deleteM) {
                this.delete();
                return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store
                    .dispatch(this.table + "/insert", {
                        titulo: this.editedItem.titulo,
                        descricao: this.editedItem.descricao,
                        data: this.$moment().format('YYYY-MM-DD HH:mm'),
                        clientes: this.clientes.map((el) => {
                            return el.id_utilizador
                        }).filter((el) => {
                            return el > 0
                        })
                    })
                    .then((res) => {
                        if (res) {
                            this.toast('success', this.messages.add.success);
                            this.initialize();
                        } else this.toast('error', this.messages.add.error);

                        this.modal = false;
                    });
            } else {
                this.$store
                    .dispatch(this.table + "/update", {
                        id: this.editedItem.id_aviso,
                        titulo: this.editedItem.titulo,
                        descricao: this.editedItem.descricao,
                        data: this.$moment().format('YYYY-MM-DD HH:mm')
                    })
                    .then((res) => {
                        if (res) {
                            this.toast('success', this.messages.update.success);
                            this.initialize();
                        } else this.toast('error', this.messages.update.error);

                        this.modal = false;
                    });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/Table_Avisos.vue